<h1 mat-dialog-title>Crear plan de carrera a partir de plantilla</h1>

<mat-dialog-content [formGroup]="form">
  <div style="display: flex; gap: 16px; align-items: flex-end; margin-top: 10px">
    <mat-form-field appearance="outline" style="flex: 1">
      <mat-label>Plantilla</mat-label>
      <mat-select formControlName="templateId" required>
        @for (template of templates; track template) {
          <mat-option [value]="template.id">
            {{ template.title }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" style="flex: 1">
      <mat-label>Fecha de inicio</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="currentFrom" [min]="minDate" required />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="accent" (click)="submit()" [disabled]="form.invalid">Crear</button>
</mat-dialog-actions>
